/**
 * 存放全局方法，可直接调用
 */
import find from 'lodash/find';

const common = {
  install: function(Vue) {
    /** 计算内容区域的高度，视窗高度-header高度 */
    Vue.prototype.$calcWrapHeight = function() {
      return document.documentElement.clientHeight - 46;
    };
    // 由一个组件，向下找到最近的指定组件
    Vue.prototype.$findComponentDownward = function(context, componentName) {
      const childrens = context.$children;
      let children = null;

      if (childrens.length) {
        for (const child of childrens) {
          const name = child.$options.name;
          if (name === componentName) {
            children = child;
            break;
          } else {
            children = context.$findComponentDownward(child, componentName);
            if (children) break;
          }
        }
      }
      return children;
    };
    // 由一个组件，向上找到最近的指定组件
    Vue.prototype.$findComponentUpward = function(context, componentName) {
      let parent = context.$parent;
      let name = parent.$options.name;

      while (parent && (!name || [componentName].indexOf(name) < 0)) {
        parent = parent.$parent;
        if (parent) name = parent.$options.name;
      }
      return parent;
    };
    // 找到对应的校本服务器接口地址
    Vue.prototype.$findTargetSchoolIp = function(ips, type) {
      const prefixs = ['', '', '/resPlatform', '/public', '/patrol'];
      const target = find(ips, {
        serverType: type
      });
      // 兼容早期8401版本
      if (target.port === '8401' || target.port === '8302') {
        return target && `${target.ip}:${target.port}`;
      } else {
        return target && `${target.ip}:${target.port}${prefixs[type]}`;
      }
    };
    Vue.prototype.$findStoragePort = function(ips) {
      const target = find(ips, {
        serverType: 1
      });
      return target.port;
    };
    Vue.prototype.$isIos = function() {
      const platform = navigator.userAgent;
      if (platform.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        return true;
      } else {
        return false;
      }
    };
    Vue.prototype.$checkMobile = function(mobile) {
      const regex = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
      const mMobile = parseInt(mobile.replace(/\s+/g, ''), 10);
      if (typeof mMobile !== 'number') {
        return false;
      }

      return regex.test(mMobile);
    };
    Vue.prototype.$strToDate = function(date) {
      let datetime = date;
      if (typeof date === 'string') {
        datetime = new Date(datetime.split('-').join('/'));
      }
      return datetime;
    };
    Vue.prototype.$share = function(context, data) {
      const jsonStr = JSON.stringify(data);
      if (context.$isIos()) {
        window.webkit.messageHandlers.externalShare.postMessage(jsonStr);
      } else {
        NativeApi.externalShare(jsonStr);
      }
    };
    Vue.prototype.$getShareIcon = function(type) {
      if (type === 'live') {
        return `${window.location.origin}/icon-live.png`;
      } else {
        return `${window.location.origin}/icon-video.png`;
      }
    };
    Vue.prototype.$getLiveShareUrl = function(live) {
      const url = `${window.location.origin}/Lives.html/live/${live.id}/${live.liveId}/${
        live.streamCode
      }/${live.userPhone}`;
      return url;
    };
  }
};

export default common;
